import { useSelector } from 'react-redux';

import DeleteFieldset from '@/components/atoms/Fieldset/templates/IntegrationsFieldset/DeleteFieldset';
import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectIntegrationId } from '@/redux/session/selectors';
import { IntercomIntegration } from '@/shared/types/integration';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import IntercomRedirectFieldset from './fieldsets/IntercomRedirectFieldset';

interface Props {
  onAuthClick: () => void;
}

const IntercomOauth = ({ onAuthClick }: Props) => {
  const deskId = useDeskId();
  const integrationId = useSelector(selectIntegrationId);
  const { integration } = useIntegrations<IntercomIntegration>(deskId, integrationId);

  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'integrations', actions.WRITE)
  );

  return (
    <div className="flex flex-col gap-4">
      <IntercomRedirectFieldset onAuthClick={onAuthClick} disabled={!canWrite} />
      <DeleteFieldset integration={integration} disabled={!canWrite} />
    </div>
  );
};

export default IntercomOauth;
